import { CheckCircleFilledIcon } from '@approvalmax/ui';
import { Box, Button, Collapse, Grid, Text } from '@approvalmax/ui/src/components';
import { FC, memo, useMemo } from 'react';

import { CircleWithDigit } from './CollapseSection.styles';
import { CollapseSectionProps } from './CollapseSection.types';

export const CollapseSection: FC<CollapseSectionProps> = memo((props) => {
    const { title, buttonText, buttonLink, number, complete, collapsed, children, onButtonClick } = props;

    const startIcon = useMemo(
        () =>
            complete ? (
                <CheckCircleFilledIcon size={20} color='blue100' />
            ) : (
                <CircleWithDigit>
                    <Text font='label' fontSize='small' color='blue100'>
                        {number}
                    </Text>
                </CircleWithDigit>
            ),
        [complete, number]
    );

    const linkProps = buttonLink
        ? {
              as: 'a' as const,
              target: '_blank',
              href: buttonLink,
          }
        : {};

    return (
        <Collapse
            collapsed={collapsed}
            alignCollapseIcon='right'
            startIcon={startIcon}
            name={title}
            bordered
            radius='small'
        >
            <Box spacing='0 24 16'>
                {children}

                {buttonText && (buttonLink || onButtonClick) && (
                    <Grid padding='32 0 0' justifyContent='end'>
                        <Button color='blue80' size='small' onClick={onButtonClick} {...linkProps}>
                            {buttonText}
                        </Button>
                    </Grid>
                )}
            </Box>
        </Collapse>
    );
});

CollapseSection.displayName = 'CollapseSection';
